module.exports = __webpack_public_path__ + "static/media/uitgebreid_zoeken.075e25c9.png";